import angular from 'angular'
import angularMoment from 'angular-moment'

export default angular.module('ljungmann.filters.duration', [
  angularMoment
])
  .filter('duration', function (moment) {
    'ngInject'
    // Converts milliseconds to human readable format
    return function (input) {
      if (input == null) {
        return ''
      }

      if (isNaN(parseFloat(input)) || !isFinite(input)) {
        return 'NaN'
      }

      const duration = moment.duration(input)
      const durationHours = duration.hours()
      const durationMinutes = duration.minutes()
      const durationSeconds = duration.seconds()

      const h = durationHours > 0 ? durationHours + ':' : ''
      const m = (h.length > 0 && durationMinutes < 10 ? '0' : '') + durationMinutes + ':'
      const s = (durationSeconds < 10 ? '0' : '') + durationSeconds

      return h + m + s
    }
  })
  .name
